<template>
  <div>
    <template v-if="arrayAgents.length">
      <h2 class="general-indicators__section-title">Информация домофонов по агентам</h2>
      <v-row>
        <table class="custom-table" @touchstart.stop>
          <thead>
            <tr>
              <th v-for="header in headers" :key="header">{{ header }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in objectTotal" :key="key">
              <td>{{ titleDisplay(key) }}</td>
              <td>{{ value }}</td>
              <td v-for="agent in arrayAgents" :key="agent.id">{{ agent.doorphones[key] }}</td>
            </tr>
          </tbody>
        </table>
        <div class="ma-2" v-if="displayLoadingIndicators">
          <v-progress-circular color="primary" indeterminate></v-progress-circular>
        </div>
      </v-row>
    </template>

    <div class="general-indicators__section mt-4" v-if="arrayManagements.length">
      <h2 class="general-indicators__section-title">Собственники управляющих компаний</h2>
      <v-row>
        <table class="custom-table" @touchstart.stop>
          <thead>
            <tr>
              <th v-for="item in arrayManagements" :key="item.id">{{ item.name }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td v-for="(tmp, key) in arrayManagements" :key="key">{{ tmp.doorphones_count }}</td>
            </tr>
          </tbody>
        </table>
      </v-row>
    </div>

    <div class="ma-2" v-if="displayLoading">
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GeneralIndicatorsAgentsSection',
  props: {
    arrayAgents: {
      type: Array,
      default: () => [],
    },
    arrayManagements: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    objectTotal: {
      type: Object,
      default: () => ({}),
    },
    displayLoadingIndicators: {
      type: Boolean,
      default: false,
    },
    displayLoading: {
      type: Boolean,
      default: false,
    },
    titleDisplay: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.general-indicators__section-title {
  font-size: 1.25rem;
  font-weight: 400;
  color: #37474f;
  margin: 0 0 12px 0;
  letter-spacing: -0.01em;
}
</style>
